"use strict";

exports.__esModule = true;
var _uiPreferences = require("./uiPreferences");
Object.keys(_uiPreferences).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _uiPreferences[key]) return;
  exports[key] = _uiPreferences[key];
});
var _uiPreferencesApi = require("./uiPreferencesApi");
Object.keys(_uiPreferencesApi).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _uiPreferencesApi[key]) return;
  exports[key] = _uiPreferencesApi[key];
});
var _UiPreferencesContext = require("./UiPreferencesContext");
Object.keys(_UiPreferencesContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UiPreferencesContext[key]) return;
  exports[key] = _UiPreferencesContext[key];
});
var _UiPreferencesProvider = require("./UiPreferencesProvider");
Object.keys(_UiPreferencesProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UiPreferencesProvider[key]) return;
  exports[key] = _UiPreferencesProvider[key];
});
var _UiPreferencesDialog = require("./UiPreferencesDialog");
Object.keys(_UiPreferencesDialog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UiPreferencesDialog[key]) return;
  exports[key] = _UiPreferencesDialog[key];
});
var _UiModeToggle = require("./UiModeToggle");
Object.keys(_UiModeToggle).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _UiModeToggle[key]) return;
  exports[key] = _UiModeToggle[key];
});